import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { TransactionHistoryRequest } from '../api/myaccount/transactionhistory/transactionhistoryrequest';
import { TransactionHistoryResponse, TransactionHistoryResponseDtoImpl } from '../api/myaccount/transactionhistory/transactionhistoryresponse';
import { TransactionHistoryBuilder } from '../dto/transactionhistory/transactionhistorybuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class TransactionHistoryAPIProcessorImpl extends SixdeeCRBTAPIProcessor<TransactionHistoryRequest, TransactionHistoryResponse>
{

    execute(request: TransactionHistoryRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new TransactionHistoryResponseDtoImpl(APIFeatures.TRANSACTION_HISTORY, "Transaction History Success");

                let transactionDetailsList = new TransactionHistoryBuilder(responseMapper.getResponseMap(), this.getContext()).buildAll();
                response.setTransactionHistoryDtos(transactionDetailsList);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new TransactionHistoryResponseDtoImpl(APIFeatures.TRANSACTION_HISTORY, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new TransactionHistoryResponseDtoImpl(APIFeatures.TRANSACTION_HISTORY, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new TransactionHistoryResponseDtoImpl(APIFeatures.TRANSACTION_HISTORY, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
     
            this.getAPIFailure(new TransactionHistoryResponseDtoImpl(APIFeatures.TRANSACTION_HISTORY, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/transactionhistoryapiprocessor.tsx